import { DROPDOWN } from 'baseConfig/pg/constants';

const DOWNLOAD_REPORT = 'Download';

const RISK_TRANSACTIONS = 'RISK_TRANSACTIONS';

export const REPORT_FILTER_ITEMS = [
  {
    key: 'IMPORT_TRANSACTION',
    text: 'Transactions',
    value: 'xb_import_transaction_report',
  },
  {
    key: 'IMPORT_TRANSACTION_VERIFICATION',
    text: 'Transactions Verification',
    value: 'xb_import_transaction_verification_report',
  },
  {
    key: 'IMPORT_TRANSACTION_VERIFICATION_DOC_DETAILS',
    text: 'Transactions Verification Documents Details',
    value: 'xb_import_transaction_verification_doc_details_report',
  },
  {
    key: 'IMPORT_SETTLEMENT',
    text: 'Settlements',
    value: 'xb_import_settlement_report',
  },
  {
    key: 'IMPORT_SETTLEMENT_RECON',
    text: 'Settlements Recon',
    value: 'xb_import_settlement_recon_report',
  },
  {
    key: 'IMPORT_LEDGER',
    text: 'Ledger',
    value: 'xb_import_ledger_report',
  },
  {
    key: 'REFUNDS',
    text: 'Refunds',
    value: 'pg_refund_report',
  },
  {
    key: 'DISPUTES',
    text: 'Disputes',
    value: 'dispute_order',
  },
  {
    key: 'PRODUCT_LINK_ORDERS',
    text: 'Product Link Orders',
    value: 'pg_product_txn_report',
  },
  {
    key: 'PAYMENT_FORM',
    text: 'Payment Form',
    value: 'pg_payment_form_report',
  },
  {
    key: RISK_TRANSACTIONS,
    text: 'Risk Transactions',
    value: 'risk_transaction',
  },
  {
    key: 'PAYTM',
    text: 'Paytm',
    value: 'pg_paytm_summary_report',
  },
];

export default {
  [DOWNLOAD_REPORT]: {
    FILTER_ITEMS: {
      type: {
        displayText: 'Type',
        type: DROPDOWN,
        items: REPORT_FILTER_ITEMS,
      },
    },
  },
};
